import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Banner1.css';

const Banner1 = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const navigation = useNavigate();
  const [dots, setDots] = useState([]);

  useEffect(() => {
    // Generate random radar dots
    const generateDots = () => {
      const newDots = [];
      for (let i = 0; i < 15; i++) {
        const angle = Math.random() * Math.PI * 2;
        const distance = 20 + Math.random() * 60; // Between 20% and 80% from center
        const x = Math.cos(angle) * distance;
        const y = Math.sin(angle) * distance;
        newDots.push({ x: `${x}%`, y: `${y}%` });
      }
      setDots(newDots);
    };

    generateDots();
    const interval = setInterval(generateDots, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div id="home" className="banner-container">
      {/* Background Images */}
      <div className="background-overlay">
        {/* Desktop Image Layout */}
        <div className="desktop-image-container">
            <img
              src="/images/homepageimage.png"
              alt="IINSAF Home"
            className="desktop-bg-image"
            />
        </div>

        {/* Mobile Image Layout */}
        <div className="mobile-image-container">
          <img
            src="/images/homepageimage.png"
            alt="IINSAF Home"
            className="mobile-bg-image"
          />
        </div>
      </div>

      {/* Radar Effect */}
      <div className="radar-container">
        <div className="radar-glow"></div>
        <div className="radar-grid"></div>
        <div className="radar-sweep"></div>
        <div className="radar-dots">
          {dots.map((dot, index) => (
            <div
              key={index}
              className="radar-dot"
              style={{ left: dot.x, top: dot.y }}
            />
          ))}
        </div>
      </div>
      
      <div className="gradient-overlay"></div>

  {/* Content Section */}
      <div className="content-wrapper">
        {currentSlide === 1 && (
          <div className="main-content">
            {/* Hero Section */}
            <div className="hero-section">
              <div className="hero-badge">
                <span className="badge-text">Welcome to</span>
                <span className="brand-name">IINSAF</span>
            </div>
              
              <h1 className="hero-title">
                <span className="title-highlight">International Influencing</span>
                <span className="title-subtitle">News Social Media Advertisement Federation</span>
              </h1>
              
              <p className="hero-description">
                Empowering voices, connecting communities, and driving digital innovation across India's media landscape.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="action-buttons">
              {/* Primary Action */}
              <div className="primary-action">
              <button
                  className="btn-primary"
                onClick={() => {
                  const token = localStorage.getItem('token');
                  if (!token) {
                    navigation("/raise/register");
                  } else {
                    navigation("/raise/login");
                  }
                }}
              >
                  <span className="btn-icon">📢</span>
                  <span className="btn-text">Raise Your Voice</span>
                  <span className="btn-arrow">→</span>
              </button>
              </div>
              
              {/* Secondary Actions */}
              <div className="secondary-actions">
              <button
                  className="btn-secondary btn-green"
                onClick={() => {
                  const token = localStorage.getItem('token');
                  if (!token) {
                    navigation("/auth/login");
                  } else {
                    navigation("/darbar-register");
                  }
                }}
              >
                  <span className="btn-icon">🏛️</span>
                  <span className="btn-text">जनसेवा दरबार</span>
              </button>
              
              <button
                  className="btn-secondary btn-blue"
                onClick={() => {
                  const token = localStorage.getItem('token');
                  if (!token) {
                    navigation("/press/login");
                  } else {
                    navigation("/press/login");
                  }
                }}
              >
                  <span className="btn-icon">📰</span>
                  <span className="btn-text">Press Conference</span>
              </button>
              
              <button
                  className="btn-secondary btn-purple"
                onClick={() => {
                  const token = localStorage.getItem('token');
                  if (!token) {
                    navigation("/podcast/login");
                  } else {
                    navigation("/podcast/register");
                  }
                }}
                >
                  <span className="btn-icon">🎙️</span>
                  <span className="btn-text">Podcast Studio</span>
              </button>

              </div>
            </div>
          </div>
        )}
        
        {currentSlide === 2 && (
          <div className="secondary-content">
            <h1 className="secondary-title">
              Digital Innovation Hub
            </h1>
            
            <p className="secondary-description">
              Helping your brand thrive in the digital era with innovative solutions and cutting-edge technology.
            </p>
            
            <div className="secondary-buttons">
              <button
                className="btn-secondary btn-black"
                onClick={() => navigation("/darbarRegister")}
              >
                जनसेवा दरबार
              </button>
              
              <button
                className="btn-secondary btn-red"
                onClick={() => navigation("/raise/register")}
              >
                Raise Your Voice
              </button>
              
              <button
                className="btn-secondary btn-purple"
                onClick={() => navigation("/podcast")}
              >
                <span className="btn-icon">🎙️</span>
                Podcast
              </button>
              
              <button
                className="btn-secondary btn-orange"
                onClick={() => navigation("/advocate/register")}
              >
                <span className="btn-icon">⚖️</span>
                Advocate Register
              </button>
            </div>
          </div>
        )}
      </div>
      
      <div className="bottom-glow"></div>
    </div>
  );
};

export default Banner1;




